import { ETrackType, IFaq } from '../models/faq.model';
import { IPaginationData, IPaginationQuery, request } from './base';

function getList(
  query: IPaginationQuery & {
    track: ETrackType;
    order?: 'ASC' | 'DESC';
    sort_by?: string;
    keyword?: string;
  },
) {
  return request<IPaginationData<IFaq>>({
    url: '/faq',
    method: 'GET',
    params: query,
  });
}

function getDetail(id: string) {
  return request<IFaq>({
    url: `/faq/${id}`,
    method: 'GET',
  });
}

function create(data: Partial<IFaq>) {
  return request<IFaq>({
    url: `/faq`,
    method: 'POST',
    data,
  });
}

function update(id: string, data: Partial<IFaq>) {
  return request<IFaq>({
    url: `/faq/${id}`,
    method: 'PATCH',
    data,
  });
}

function remove(id: string) {
  return request<IFaq>({
    url: `/faq/${id}`,
    method: 'DELETE',
  });
}

const faqApi = Object.freeze({
  getList,
  getDetail,
  update,
  create,
  remove,
});

export default faqApi;
